module.exports = __webpack_public_path__ + "media/images/premium/premium_ui_tw_01-900-554f709802244775e6301a5a4e4e9e60.png";